/* eslint-disable react/jsx-key */
import React from 'react'
import { strCol, dateCol, numCol } from '@integec/grid-tools/lib/cols'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
import moment from 'moment'
import {
  modifierCol,
  modifiedDateCol,
  retiredTypes,
  YNBooleanTypes,
  utilityHeader,
} from 'core/HeaderColTypeProps'
import { getApiTargetInfo } from 'core'
import { connect } from 'react-redux'
import {
  getAllUnitInfo,
  postUnitInfo,
  deleteUnitInfo,
  getRuleSetInfo,
  getFuelCodeInfo,
  getStationInfo,
  getUtilityNameMap,
  getAuthorization,
  getCredentials,
} from 'api/pgads.js'
import { loadDataForDate } from 'core/actions'
import R from 'ramda'
import CommonScreen from '../CommonScreen'
import {
  getUnitTypeCode,
  getClientInfo,
  getPermitActions,
} from 'core/selectors'
import UnitModal from './unitModal'
import {
  SpinContext,
  ErrorContext,
  JcTmpErrorContext,
  DatePickerContext,
} from 'context'
import * as ACT from 'core/action-names'
import { timeZones } from 'core/utils'
import {
  APS_CLIENT,
  BROOKFIELD_CLIENT,
  CPS_CLIENT,
  NE_NEW_ENGLAND,
  NYISO_CLIENT,
  WEE_CLIENT,
  CALPLINE_CLIENT,
  CLECO,
  LANYARD_CLIENT,
} from 'client'
import { Button, Icon, Upload, message } from 'antd'
import { isErrorContains } from 'core/component/JcTmpErrorDialog'
import { hasAccesPermits } from '../../../core/utils'
import { UNITS_SHOW_PNODEID } from '../../../core/EventActions'
import { NVENERGY } from '../../../client'

export const loadCharTypes = {
  1: '1 - Base Load',
  2: '2 - Periodic Startup',
  3: '3 - Weekly Startup',
  4: '4 - Daily Startup',
  5: '5 - Startup for Peaks',
  6: '6 - Other',
  7: '7 - Seasonal Operation',
}

// export const NVEnergyloadCharTypes = {
//   1: '1 - Base Load',
//   2: '2 - Periodic Startup',
//   3: '3 - Weekly Startup',
//   4: '4 - Daily Startup',
//   5: '5 - Startup for Peaks',
//   6: '6 - Daily start up with load-following and taken off-line during solar hours',
//   7: '7 - Seasonal Operation',
// }

export const NVEnergyloadCharTypes = loadCharTypes

const headers = CLIENT => [
  // dateCol({ ident: 'effectiveDate', display: 'Effective Date', isKey: true }),
  utilityHeader,
  strCol({ ident: 'unit', display: 'Unit Code', isKey: true }),
  strCol({
    ident: 'unitName',
    display: 'Unit Name',
    width: 250,
    isRequired: true,
    isFiltered: true,
    ellipsis: true,
  }),
  strCol({
    ident: 'shortName',
    display: 'Short Name',
    isRequired: true,
    isFiltered: true,
  }),
  dateCol({
    ident: 'commissionDate',
    display: 'Commencement Date',
    isRequired: true,
    dataFormat: 'MM/DD/YYYY',
  }),
  strCol({
    ident: 'retired',
    display: 'Retired',
    ...toSelectionColProps(retiredTypes),
    isRequired: true,
  }),
  strCol({
    ident: 'retiredDate',
    display: 'Retired Date',
  }),
  strCol({
    ident: 'station',
    display: 'Station',
    width: 300,
  }),
  strCol({
    ident: 'emsId',
    display: 'EMS ID',
  }),
  strCol({
    ident: 'id1',
    display: 'Unit Type',
    width: 200,
  }),
  strCol({
    ident: 'id2',
    display: 'Send To NERC',
    ...toSelectionColProps(YNBooleanTypes),
  }),
  strCol({
    ident: 'id3',
    display: 'Spare ID 1',
    width: 200,
  }),
  strCol({
    ident: 'id4',
    display: 'Block ID',
  }),
  strCol({
    ident: 'rStationCode',
    display: 'Track Hydro Event',
    ...toSelectionColProps(YNBooleanTypes),
  }),
  strCol({
    ident: 'runItCode',
    display: 'Track Gross Values',
    ...toSelectionColProps(YNBooleanTypes),
  }),
  strCol({
    ident: 'rsRequired',
    display: 'Track Reserve Events',
    isRequired: true,
    ...toSelectionColProps(YNBooleanTypes),
  }),
  strCol({
    ident: 'dailyDetail',
    display: 'Track Daily Detail',
    isRequired: true,
    ...toSelectionColProps(YNBooleanTypes),
  }),
  strCol({
    ident: 'daylightSavings',
    display: 'Observe Daylight Savings',
    isRequired: true,
    ...toSelectionColProps(YNBooleanTypes),
  }),
  strCol({
    ident: 'ruleSet',
    display: 'Rule Set',
    isRequired: true,
  }),
  strCol({
    ident: 'timeZone',
    display: 'Time Zone',
    isRequired: true,
    ...toSelectionColProps(timeZones),
    width: 150,
  }),
  numCol({
    ident: 'netMaxCapSum',
    display: 'Summer Net Max Cap',
    isRequired: true,
  }),
  numCol({
    ident: 'netMaxCapWin',
    display: 'Winter Net Max Cap',
    isRequired: true,
  }),
  numCol({
    ident: 'instCapSum',
    display: 'Summer Installed Cap',
    isRequired: true,
  }),
  numCol({
    ident: 'instCapWin',
    display: 'Winter Installed Cap',
    isRequired: true,
  }),
  strCol({
    ident: 'loadingChar',
    display: 'Loading Characteristics',
    ...toSelectionColProps(
      CLIENT === NVENERGY ? NVEnergyloadCharTypes : loadCharTypes
    ),
    ellipsis: true,
    alignment: 'left',
    width: 150,
  }),
  strCol({
    ident: 'primaryFuel',
    display: 'Primary Fuel',
    width: 200,
  }),
  strCol({
    ident: 'secondaryFuel',
    display: 'Secondary Fuel',
    width: 200,
  }),
  strCol({
    ident: 'tertiaryFuel',
    display: 'Tertiary Fuel',
    width: 200,
  }),
  strCol({
    ident: 'quarternaryFuel',
    display: 'Quaternary Fuel',
    width: 200,
  }),
  // modifierCol,
  // modifiedDateCol,
]

const pnodeHeaders = [
  strCol({
    ident: 'pnodeId',
    display: 'Pnode Id',
    width: 150,
    ellipsis: true,
  }),
  strCol({
    ident: 'emktId',
    display: 'eMarket Id',
    width: 150,
    ellipsis: true,
  }),
  strCol({
    ident: 'rollupEmktId',
    display: 'Rollup eMarket Id',
    width: 200,
    ellipsis: true,
  }),
]

export const emptyId = '[NA]'

const modifySaveDataBeforeSave = (saveData, _, CLIENT) => {
  let data = saveData.map(d => ({
    ...d,
    commissionDate: moment(d.commissionDate, 'MM/DD/YYYY').format('YYYY-MM-DD'),
    retiredDate:
      d.retiredDate &&
      (d.retiredDate.length > 0 || d.retiredDate !== 'Invalid date')
        ? moment(d.retiredDate, 'MM/DD/YYYY').format('YYYY-MM-DD')
        : undefined,
    primaryFuel: d.primaryFuel === emptyId ? undefined : d.primaryFuel,
    secondaryFuel: d.secondaryFuel === emptyId ? undefined : d.secondaryFuel,
    tertiaryFuel: d.tertiaryFuel === emptyId ? undefined : d.tertiaryFuel,
    quarternaryFuel:
      d.quarternaryFuel === emptyId ? undefined : d.quarternaryFuel,
    station: d.station === '[]' ? undefined : d.station,
  }))
  // let isValid = true
  // data.forEach(d => {
  //   const valid = validateData(d)
  //   isValid = valid
  //   if (!valid) return false
  // })
  // if (!isValid) return false
  if (CLIENT === NYISO_CLIENT) {
    data = data.map(d => ({
      ...d,
      emsId: d.emsId === 'CO-PU' ? 'CO-PU' : null,
    }))
  }
  return data
}

const sortOnData = data =>
  data.map(d => ({
    ...d,
    commissionDate: moment(d.commissionDate).format('MM/DD/YYYY'),
    retiredDate: d.retiredDate
      ? moment(d.retiredDate).format('MM/DD/YYYY')
      : undefined,
  }))

const retrieveTask = apiTargetInfo => getAllUnitInfo(apiTargetInfo)
// .map(d => ({
//   ...d,
//   retiredDate: d.retiredDate
//     ? moment(d.retiredDate).format('MM/DD/YYYY')
//     : undefined,
// }))

// const modifyTask = apiTargetInfo => (data, isNew = false) => {
//   // const modData = data.map(d => ({
//   //   ...d,
//   //   primaryFuel:d.primaryFuel===emptyId ? undefined  : d.primaryFuel,
//   //   secondaryFuel:d.secondaryFuel===emptyId ? undefined  : d.secondaryFuel,
//   //   tertiaryFuel:d.tertiaryFuel===emptyId ? undefined  : d.tertiaryFuel,
//   //   quarternaryFuel:d.quarternaryFuel===emptyId ? undefined  : d.quarternaryFuel,
//   // }))
//   // our api only accpets arrays of data
//   return postUnitInfo(apiTargetInfo)(data, isNew)
// }

const deleteTask = apiTargetInfo => data => deleteUnitInfo(apiTargetInfo)(data) // our api only accpets arrays of data

const title = 'Units'

const processFuelCode = R.compose(
  R.fromPairs,
  R.map(a => [a.code, a.code + ' - ' + a.description || a.code])
)
const processRuleSet = R.compose(
  R.fromPairs,
  R.map(a => [a.ruleSet, a.ruleSet])
)

const processStation = R.compose(
  R.fromPairs,
  R.map(a => [a.station, a.stationName])
)

const defaultInsertData = {
  // effectiveDate : moment().format('YYYY-MM-DD')
}
class Unit extends React.Component {
  state = {
    fuelCode: {},
    ruleSetTypes: {},
    utilityNameMap: {},
    stationType: {},
    insertEvent: false,
    insertData: defaultInsertData,
  }

  insertModal = ({ retrieve, validateData }) => (
    <UnitModal
      CLIENT={this.props.CLIENT}
      hide={() => this.setState({ insertEvent: false })}
      // onError={this.setErr}
      setError={this.props.setError}
      isNew
      // createTask={modifyTask}
      unitTypes={this.props.unitTypeCode}
      utilityNameMap={this.state.utilityNameMap}
      fuelCodes={this.state.fuelCode}
      timeZones={timeZones}
      stationType={this.state.stationType}
      ruleSetTypes={this.state.ruleSetTypes}
      loadCharTypes={
        this.props.CLIENT === NVENERGY ? NVEnergyloadCharTypes : loadCharTypes
      }
      loadDataForDate={this.props.loadDataForDateSave}
      date={this.props.date}
      retrieve={retrieve}
      saveUnitNameMap={this.props.saveUnitNameMap}
      apiTargetInfo={this.props.apiTargetInfo}
      validateData={validateData}
      spinning={this.props.loading}
      fuelCodeDataList={this.state.fuelCodeDataList || []}
      setSpinning={this.props.setSpinning}
    />
  )

  componentDidMount() {
    const { apiTargetInfo } = this.props

    getFuelCodeInfo(apiTargetInfo).fork(this.props.setError, fuelCode =>
      this.setState({
        fuelCode: processFuelCode([
          { code: emptyId, description: 'None' },
          ...fuelCode,
        ]),
        fuelCodeDataList: [{ code: emptyId, description: 'None' }, ...fuelCode],
      })
    )

    getRuleSetInfo(apiTargetInfo)
      .map(processRuleSet)
      .fork(this.props.setError, ruleSetTypes =>
        this.setState({ ruleSetTypes })
      )

    getStationInfo(apiTargetInfo)
      .map(processStation)
      .fork(this.props.setError, stationType => this.setState({ stationType }))

    getUtilityNameMap(apiTargetInfo)().fork(
      this.props.setError,
      utilityNameMap => this.setState({ utilityNameMap })
    )
  }

  render() {
    const { CLIENT } = this.props
    const { utilityNameMap } = this.state
    const { fuelCode, ruleSetTypes, stationType } = this.state
    const showPnodeIds = hasAccesPermits({
      actionPermits: this.props.actionPermits,
      eventActions: [UNITS_SHOW_PNODEID],
      matchAny: true,
    })

    const clecoheaders = [
      // dateCol({ ident: 'effectiveDate', display: 'Effective Date', isKey: true }),
      utilityHeader,
      strCol({ ident: 'unit', display: 'Unit Code', isKey: true }),
      strCol({
        ident: 'unitName',
        display: 'Unit Name',
        width: 250,
        isRequired: true,
        isFiltered: true,
        ellipsis: true,
      }),
      strCol({
        ident: 'shortName',
        display: 'Short Name',
        isRequired: true,
        isFiltered: true,
      }),
      dateCol({
        ident: 'commissionDate',
        display: 'Commencement Date',
        isRequired: true,
        dataFormat: 'MM/DD/YYYY',
      }),
      strCol({
        ident: 'retired',
        display: 'Retired',
        ...toSelectionColProps(retiredTypes),
        isRequired: true,
      }),
      strCol({
        ident: 'retiredDate',
        display: 'Retired Date',
      }),
      strCol({
        ident: 'station',
        display: 'Station',
        width: 300,
      }),
      strCol({
        ident: 'emsId',
        display: 'EMS ID',
      }),
      strCol({
        ident: 'id1',
        display: 'Unit Type',
        width: 200,
      }),
      strCol({
        ident: 'id2',
        display: 'Send To NERC',
        ...toSelectionColProps(YNBooleanTypes),
      }),
      strCol({
        ident: 'id3',
        display: CLIENT === NE_NEW_ENGLAND ? 'NERC Class ID' : 'Spare ID 1',
        width: 200,
      }),
      strCol({
        ident: 'id4',
        display:
          CLIENT === CLECO || CLIENT === NE_NEW_ENGLAND
            ? 'Block ID'
            : CLIENT === LANYARD_CLIENT
            ? 'CC Block ID'
            : 'Spare ID 2',
      }),
      strCol({
        ident: 'runItCode',
        display:
          CLIENT === CLECO || CLIENT === NE_NEW_ENGLAND
            ? 'Spare ID 2'
            : CLIENT === LANYARD_CLIENT
            ? 'Spare ID 3'
            : 'Block ID',
        // ...toSelectionColProps(YNBooleanTypes),
      }),
      strCol({
        ident: 'rStationCode',
        display:
          CLIENT === LANYARD_CLIENT
            ? 'Spare ID 2'
            : CLIENT === NE_NEW_ENGLAND
            ? 'Track Hydro Event'
            : 'Spare ID 3',
        ...(CLIENT === NE_NEW_ENGLAND
          ? toSelectionColProps(YNBooleanTypes)
          : {}),
        // ...toSelectionColProps(YNBooleanTypes),
      }),

      strCol({
        ident: 'rsRequired',
        display: 'Track Reserve Events',
        isRequired: true,
        ...toSelectionColProps(YNBooleanTypes),
      }),
      strCol({
        ident: 'dailyDetail',
        display: 'Track Daily Detail',
        isRequired: true,
        ...toSelectionColProps(YNBooleanTypes),
      }),
      strCol({
        ident: 'daylightSavings',
        display: 'Observe Daylight Savings',
        isRequired: true,
        ...toSelectionColProps(YNBooleanTypes),
      }),
      strCol({
        ident: 'ruleSet',
        display: 'Rule Set',
        isRequired: true,
      }),
      strCol({
        ident: 'timeZone',
        display: 'Time Zone',
        isRequired: true,
        ...toSelectionColProps(timeZones),
      }),
      numCol({
        ident: 'netMaxCapSum',
        display: 'Summer Net Max Cap',
        isRequired: true,
      }),
      numCol({
        ident: 'netMaxCapWin',
        display: 'Winter Net Max Cap',
        isRequired: true,
      }),
      numCol({
        ident: 'instCapSum',
        display: 'Summer Installed Cap',
        isRequired: true,
      }),
      numCol({
        ident: 'instCapWin',
        display: 'Winter Installed Cap',
        isRequired: true,
      }),
      strCol({
        ident: 'loadingChar',
        display: 'Loading Characteristics',
        ...toSelectionColProps(loadCharTypes),
        width: 150,
      }),
      strCol({
        ident: 'primaryFuel',
        display: 'Primary Fuel',
        width: 200,
      }),
      strCol({
        ident: 'secondaryFuel',
        display: 'Secondary Fuel',
        width: 200,
      }),
      strCol({
        ident: 'tertiaryFuel',
        display: 'Tertiary Fuel',
        width: 200,
      }),
      strCol({
        ident: 'quarternaryFuel',
        display: 'Quaternary Fuel',
        width: 200,
      }),
      // modifierCol,
      // modifiedDateCol,
    ]

    const weheaders = [
      // dateCol({ ident: 'effectiveDate', display: 'Effective Date', isKey: true }),
      utilityHeader,
      strCol({ ident: 'unit', display: 'Unit Code', isKey: true }),
      strCol({
        ident: 'unitName',
        display: 'Unit Name',
        width: 250,
        isRequired: true,
        isFiltered: true,
        ellipsis: true,
      }),
      strCol({
        ident: 'shortName',
        display: 'Short Name',
        isRequired: true,
        isFiltered: true,
      }),
      dateCol({
        ident: 'commissionDate',
        display: 'Commencement Date',
        isRequired: true,
        dataFormat: 'MM/DD/YYYY',
      }),
      strCol({
        ident: 'retired',
        display: 'Retired',
        ...toSelectionColProps(retiredTypes),
        isRequired: true,
      }),
      strCol({
        ident: 'retiredDate',
        display: 'Retired Date',
      }),
      strCol({
        ident: 'station',
        display: 'Station',
        width: 300,
      }),
      strCol({
        ident: 'emsId',
        display: 'EMS ID',
      }),
      strCol({
        ident: 'id1',
        display: 'Unit Type',
        width: 200,
      }),
      strCol({
        ident: 'id2',
        display: 'Send To NERC',
        ...toSelectionColProps(YNBooleanTypes),
      }),
      strCol({
        ident: 'id3',
        display: CLIENT === NE_NEW_ENGLAND ? 'NERC Class ID' : 'Spare ID 1',
        width: 200,
      }),
      strCol({
        ident: 'id4',
        display:
          CLIENT === CLECO || CLIENT === NE_NEW_ENGLAND
            ? 'Block ID'
            : CLIENT === LANYARD_CLIENT
            ? 'CC Block ID'
            : 'Spare ID 2',
      }),
      strCol({
        ident: 'rStationCode',
        display:
          CLIENT === LANYARD_CLIENT
            ? 'Spare ID 2'
            : CLIENT === NE_NEW_ENGLAND
            ? 'Track Hydro Event'
            : 'Spare ID 3',
        ...(CLIENT === NE_NEW_ENGLAND
          ? toSelectionColProps(YNBooleanTypes)
          : {}),
        // ...toSelectionColProps(YNBooleanTypes),
      }),
      strCol({
        ident: 'runItCode',
        display:
          CLIENT === CLECO || CLIENT === NE_NEW_ENGLAND
            ? 'Spare ID 2'
            : CLIENT === LANYARD_CLIENT
            ? 'Spare ID 3'
            : 'Block ID',
        // ...toSelectionColProps(YNBooleanTypes),
      }),
      strCol({
        ident: 'rsRequired',
        display: 'Track Reserve Events',
        isRequired: true,
        ...toSelectionColProps(YNBooleanTypes),
      }),
      strCol({
        ident: 'dailyDetail',
        display: 'Track Daily Detail',
        isRequired: true,
        ...toSelectionColProps(YNBooleanTypes),
      }),
      strCol({
        ident: 'daylightSavings',
        display: 'Observe Daylight Savings',
        isRequired: true,
        ...toSelectionColProps(YNBooleanTypes),
      }),
      strCol({
        ident: 'ruleSet',
        display: 'Rule Set',
        isRequired: true,
      }),
      strCol({
        ident: 'timeZone',
        display: 'Time Zone',
        isRequired: true,
        ...toSelectionColProps(timeZones),
      }),
      numCol({
        ident: 'netMaxCapSum',
        display: 'Summer Net Max Cap',
        isRequired: true,
      }),
      numCol({
        ident: 'netMaxCapWin',
        display: 'Winter Net Max Cap',
        isRequired: true,
      }),
      numCol({
        ident: 'instCapSum',
        display: 'Summer Installed Cap',
        isRequired: true,
      }),
      numCol({
        ident: 'instCapWin',
        display: 'Winter Installed Cap',
        isRequired: true,
      }),
      strCol({
        ident: 'loadingChar',
        display: 'Loading Characteristics',
        ...toSelectionColProps(loadCharTypes),
        width: 150,
      }),
      strCol({
        ident: 'primaryFuel',
        display: 'Primary Fuel',
        width: 200,
      }),
      strCol({
        ident: 'secondaryFuel',
        display: 'Secondary Fuel',
        width: 200,
      }),
      strCol({
        ident: 'tertiaryFuel',
        display: 'Tertiary Fuel',
        width: 200,
      }),
      strCol({
        ident: 'quarternaryFuel',
        display: 'Quaternary Fuel',
        width: 200,
      }),
      // modifierCol,
      // modifiedDateCol,
    ]

    let headerWithFormatter =
      this.props.CLIENT === WEE_CLIENT ||
      this.props.CLIENT === BROOKFIELD_CLIENT ||
      this.props.CLIENT === APS_CLIENT ||
      this.props.CLIENT === CPS_CLIENT ||
      this.props.CLIENT === LANYARD_CLIENT ||
      this.props.CLIENT === NE_NEW_ENGLAND ||
      this.props.CLIENT === CALPLINE_CLIENT
        ? weheaders
        : this.props.CLIENT === NYISO_CLIENT
        ? NyIsoHeaders
        : CLIENT === CLECO
        ? clecoheaders
        : headers(this.props.CLIENT)

    if (showPnodeIds)
      headerWithFormatter = [
        ...headerWithFormatter,
        ...(this.props.CLIENT === NYISO_CLIENT
          ? NyisoPnodeHeaders
          : pnodeHeaders),
        modifierCol,
        modifiedDateCol,
      ]
    else
      headerWithFormatter = [
        ...headerWithFormatter,
        modifierCol,
        modifiedDateCol,
      ]

    headerWithFormatter = headerWithFormatter.map(h =>
      h.ident === 'utility'
        ? {
            ...h,
            // ...toSelectionColProps(utilityNameMap),
            dataFormatter: ({ value }) =>
              `${value} - ${utilityNameMap[value]}` || value,
            sortIndexGetter: ({ rowData }) =>
              `${utilityNameMap[rowData.utility]}` || rowData.utility,
          }
        : // : h.ident==='id1' ?
        // {...h,...toSelectionColProps(this.props.unitTypeCode)}
        h.ident === 'primaryFuel' ||
          h.ident === 'secondaryFuel' ||
          h.ident === 'tertiaryFuel' ||
          h.ident === 'quarternaryFuel'
        ? { ...h, ...toSelectionColProps(fuelCode) }
        : h.ident === 'ruleSet'
        ? { ...h, ...toSelectionColProps(ruleSetTypes) }
        : h.ident === 'id1'
        ? { ...h, ...toSelectionColProps(this.props.unitTypeCode) }
        : h.ident === 'station'
        ? { ...h, ...toSelectionColProps({ '[]': '', ...stationType }) }
        : h
    )

    const onRetrieveData = data => {
      // const { loadDataForDateSave } = this.props

      this.props.loadDataForDateSave(moment())
      return data
    }

    const fileProps = apiTargetInfo => ({
      name: 'file',
      action: `${apiTargetInfo.baseUrl}/ne-import/unit`,
      method: 'POST',
      headers: getAuthorization(apiTargetInfo),
      ...getCredentials(apiTargetInfo),
    })

    const extraCriteriaAfterButton = ({ onRetrieve }) => {
      const { apiTargetInfo, CLIENT, setTmpError, setSpinning } = this.props
      if (CLIENT === NE_NEW_ENGLAND)
        return (
          <Upload
            {...fileProps(apiTargetInfo)}
            beforeUpload={_ => setSpinning(true)}
            onChange={data => {
              if (data.file.status === 'error') {
                setSpinning(false)
                console.log(data)
              }
              if (data.file.status === 'done') {
                setSpinning(false)
                console.log(data)
                // setImportResponse(data.file.response)
                const errors = data.file.response
                if (errors.length > 0) setTmpError(errors)
                if (!isErrorContains(errors)) {
                  message.success('File imported successfully')
                  onRetrieve()
                }
              }
            }}
            multiple={false}
            showUploadList={false}
          >
            <Button style={{ marginLeft: '5px' }}>
              <Icon type="upload" /> Import
            </Button>
          </Upload>
        )
      else return <div />
    }

    return [
      // <h3>this screen will maintain like from pmgr</h3>,

      <CommonScreen
        extraCriteriaAfterButton={extraCriteriaAfterButton}
        title={title}
        header={headerWithFormatter}
        saveTask={postUnitInfo}
        modifySaveDataBeforeSave={modifySaveDataBeforeSave}
        retrieveTask={retrieveTask}
        deleteTask={deleteTask}
        // autoFixColByKey={false}
        // altBy={d => d.utility}
        autoRetrieve
        sortOptions={[
          { ident: 'unitName', display: 'Unit Name', sortOrder: 'asc' },
          { ident: 'utility', display: 'Utility', sortOrder: 'asc' },
          { ident: 'unit', display: 'Unit Code', sortOrder: 'asc' },
        ]}
        //        sortOptions={headerWithFormatter.map(e => ({ ...e, sortOrder: 'asc' }))}
        insertComp={this.state.insertEvent ? this.insertModal : false}
        // insertCompHeight={150}
        onInsertEvent={() => this.setState({ insertEvent: true })}
        headerRowHeight={60}
        sortOnData={sortOnData}
        onRetrieveData={onRetrieveData}
      />,
    ]
  }
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  // utilityNameMap: getUtilityNameMap(state),
  unitTypeCode: getUnitTypeCode(state),
  CLIENT: getClientInfo(state),
  actionPermits: getPermitActions(state),
})

const mapDispatchToProps = dispatch => ({
  loadDataForDateSave: selectedDate => dispatch(loadDataForDate(selectedDate)),
  saveUnitNameMap: unitNameMap =>
    dispatch({ payload: unitNameMap, type: ACT.STORE_UNIT_NAME_MAP }),
})

const WrappedUnitScreen = props => (
  <SpinContext.Consumer>
    {({ spinning, setSpinning }) => (
      <DatePickerContext.Consumer>
        {({ selectedDate }) => (
          <ErrorContext.Consumer>
            {({ error, setError }) => (
              <JcTmpErrorContext.Consumer>
                {({ tmpError, setTmpError }) => (
                  <Unit
                    date={selectedDate}
                    loading={spinning}
                    setSpinning={setSpinning}
                    error={error}
                    setError={setError}
                    setTmpError={setTmpError}
                    tmpError={tmpError}
                    {...props}
                  />
                )}
              </JcTmpErrorContext.Consumer>
            )}
          </ErrorContext.Consumer>
        )}
      </DatePickerContext.Consumer>
    )}
  </SpinContext.Consumer>
)

export default connect(mapStateToProps, mapDispatchToProps)(WrappedUnitScreen)
export const copuSelection = { 'CO-PU': 'CO-PU', emptyId: emptyId }
const NyIsoHeaders = [
  // dateCol({ ident: 'effectiveDate', display: 'Effective Date', isKey: true }),
  utilityHeader,
  strCol({ ident: 'unit', display: 'Unit Code', isKey: true }),
  strCol({
    ident: 'unitName',
    display: 'Unit Name',
    width: 250,
    isRequired: true,
    isFiltered: true,
    ellipsis: true,
  }),
  strCol({
    ident: 'shortName',
    display: 'Short Name',
    isRequired: true,
    isFiltered: true,
  }),
  dateCol({
    ident: 'commissionDate',
    display: 'Commencement Date',
    isRequired: true,
    dataFormat: 'MM/DD/YYYY',
  }),
  strCol({
    ident: 'retired',
    display: 'Inactive',
    ...toSelectionColProps(retiredTypes),
    isRequired: true,
  }),
  strCol({
    ident: 'retiredDate',
    display: 'Inactive Date',
  }),
  strCol({
    ident: 'station',
    display: 'Station',
    width: 300,
  }),
  strCol({
    ident: 'emsId',
    display: 'CO-PU Allowed',
    ...toSelectionColProps(copuSelection),
  }),
  strCol({
    ident: 'id1',
    display: 'Unit Type',
    width: 200,
  }),
  strCol({
    ident: 'id2',
    display: 'Send To NERC',
    ...toSelectionColProps(YNBooleanTypes),
  }),
  strCol({
    ident: 'id3',
    display: 'MARS Name',
    width: 200,
  }),
  strCol({
    ident: 'id4',
    display: 'Spare ID 2',
  }),
  strCol({
    ident: 'rStationCode',
    display: 'Spare ID 3',
  }),
  strCol({
    ident: 'runItCode',
    display: 'Spare ID 4',
  }),
  strCol({
    ident: 'rsRequired',
    display: 'Track Reserve Events',
    isRequired: true,
    ...toSelectionColProps(YNBooleanTypes),
  }),
  strCol({
    ident: 'dailyDetail',
    display: 'Track Daily Detail',
    isRequired: true,
    ...toSelectionColProps(YNBooleanTypes),
  }),
  strCol({
    ident: 'daylightSavings',
    display: 'Day Light Savings',
    isRequired: true,
    ...toSelectionColProps(YNBooleanTypes),
  }),
  strCol({
    ident: 'ruleSet',
    display: 'Rule Set',
    isRequired: true,
  }),
  strCol({
    ident: 'timeZone',
    display: 'Time Zone',
    isRequired: true,
    ...toSelectionColProps(timeZones),
    width: 150,
  }),
  numCol({
    ident: 'netMaxCapSum',
    display: 'Summer Net Max Cap',
    isRequired: true,
  }),
  numCol({
    ident: 'netMaxCapWin',
    display: 'Winter Net Max Cap',
    isRequired: true,
  }),
  numCol({
    ident: 'instCapSum',
    display: 'Summer Installed Cap',
    isRequired: true,
  }),
  numCol({
    ident: 'instCapWin',
    display: 'Winter Installed Cap',
    isRequired: true,
  }),
  strCol({
    ident: 'loadingChar',
    display: 'Loading Characteristics',
    ...toSelectionColProps(loadCharTypes),
    width: 150,
  }),
  strCol({
    ident: 'primaryFuel',
    display: 'Primary Fuel',
    width: 200,
  }),
  strCol({
    ident: 'secondaryFuel',
    display: 'Secondary Fuel',
    width: 200,
  }),
  strCol({
    ident: 'tertiaryFuel',
    display: 'Tertiary Fuel',
    width: 200,
  }),
  strCol({
    ident: 'quarternaryFuel',
    display: 'Quaternary Fuel',
    width: 200,
  }),
  // modifierCol,
  // modifiedDateCol,
]

const NyisoPnodeHeaders = [
  strCol({
    ident: 'pnodeId',
    display: 'PTID',
    width: 150,
    ellipsis: true,
  }),
  strCol({
    ident: 'emktId',
    display: 'Gen ID',
    width: 150,
    ellipsis: true,
  }),
  strCol({
    ident: 'rollupEmktId',
    display: 'Spare ID 7',
    width: 200,
    ellipsis: true,
  }),
]
